import "./sass/main.scss";

import "slick-carousel";

window.jQuery('.acf-button').addClass('elementor-button');
window.jQuery(document).on('click', '.elementor-post.type-kp_pledge_example a', function (e) {
    e.preventDefault();
    return false;
});


window.jQuery('.__carousel .elementor-posts-container').each(function () {
    window.jQuery(this).slick({
        dots: false,
        infinite: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }
        ]
    });
})


if(!window.jQuery('body').hasClass('home')) {
    window.scrollTo({
        top: window.jQuery('h1').offset().top - 50,
        behavior: 'smooth'
    });
}

if(window.location.hash === '#acf-form') {

    window.jQuery(document).ready(function () {

        setTimeout(function () {
            window.jQuery(window).scrollTop(window.jQuery('#acf-form').offset().top - 100)
        }, 200);
    })

}

/*
// The debounce function receives our function as a parameter
const debounce = (fn) => {

    // This holds the requestAnimationFrame reference, so we can cancel it if we wish
    let frame;

    // The debounce function returns a new function that can receive a variable number of arguments
    return (...params) => {

        // If the frame variable has been defined, clear it now, and queue for next frame
        if (frame) {
            cancelAnimationFrame(frame);
        }

        // Queue our function call for the next frame
        frame = requestAnimationFrame(() => {

            // Call our function and pass any params we received
            fn(...params);
        });

    }
};


// Reads out the scroll position and stores it in the data attribute
// so we can use it in our stylesheets
const storeScroll = () => {
    document.documentElement.dataset.scroll = window.scrollY;
}

// Listen for new scroll events, here we debounce our `storeScroll` function
document.addEventListener('scroll', debounce(storeScroll), { passive: true });

// Update scroll position for first time
storeScroll();

*/